import { createContext, type Dispatch, useContext } from 'react';

import { type AdvancedFiltersConfig } from './types/config.types';
import { type AdvancedFiltersReducerActions } from './types/reducer.types';
import { type AdvancedFiltersPrivateState } from './types/state.types';

type AdvancedFiltersContextValue = {
  state: AdvancedFiltersPrivateState;
  dispatch: Dispatch<AdvancedFiltersReducerActions>;
  config: AdvancedFiltersConfig;
};

export const AdvancedFiltersContext =
  createContext<AdvancedFiltersContextValue | null>(null);

export const useAdvancedFiltersContext = () => {
  const context = useContext(AdvancedFiltersContext);

  if (!context) {
    throw new Error(
      'useAdvancedFiltersContext must be used within a AdvancedFiltersContextProvider',
    );
  }

  return context;
};
